var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({class:{
    [_vm.$style.button]: true,
    ['button_' + _vm.resultTheme]: _vm.resultTheme,
    ['button_' + _vm.size]: _vm.size,
    ['button_disabled']: _vm.fakeDisabled,
    button_preload: _vm.loading,
    button_ghost: _vm.ghost
  },attrs:{"type":_vm.type},on:{"click":function($event){!_vm.loading ? _vm.$emit('click', $event) : null}}},'button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }